import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipResultActions } from '../../actions';

@Component({
    selector: 'bs-digital-result-keep-placed',
    templateUrl: './result-keep-placed.component.html',
    styleUrls: ['./result-keep-placed.component.scss'],
    standalone: false,
})
export class ResultKeepPlacedComponent implements OnInit {
    @Input() keepPlaced: boolean;
    @Input() betType = '';
    @Input() isLinear = false;
    @Output() keepPlacedChanged = new EventEmitter<boolean>();

    labelTitle = '';
    inputId: string;

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService,
        private store: Store<IBetslipRootState>,
    ) {
        const messages = messagesProvider.getMessages().result;
        this.labelTitle = messages.retainPlaced;
    }

    ngOnInit(): void {
        this.inputId = 'betslip-result-keep-placed' + this.betType;
    }

    onKeepPlacedChanged(value: boolean): void {
        if (this.isLinear) {
            this.keepPlacedChanged.emit(value);

            return;
        }

        this.store.dispatch(BetslipResultActions.keepPlacedBetsInBetslip({ keepPlacedBetsInBetslip: value }));
    }
}
